import request from "@/utils/request";

//气象站集合
export function weaStaList() {
  return request({
    url: "/weaSta/list",
    method: "get",
  });
}

//气象站信息
export function weaStaInfo(wsId) {
  return request({
    url: "/weaSta/info?wsId=" + wsId,
    method: "get",
  });
}

//气象站实时数据
export function weaStaRtd(wsId) {
  return request({
    url: "/weaSta/rtd?wsId=" + wsId,
    method: "get",
  });
}

//日平均气象温度
export function dayAvgT(wsId) {
  return request({
    url: "/weaSta/dayAvg?wsId=" + wsId,
    method: "get",
  });
}

//分钟气象数据
export function minWeaData(wsId) {
  return request({
    url: "/weaSta/minHis?wsId=" + wsId,
    method: "get",
  });
}

//分钟报表
export function minHis(wsId, dt) {
  return request({
    url: "/weaSta/minHisByDt?wsId=" + wsId + "&dt=" + dt,
    method: "get",
  });
}

//小时报表
export function hourHis(wsId, dt) {
  return request({
    url: "/weaSta/hourHisByDt?wsId=" + wsId + "&dt=" + dt,
    method: "get",
  });
}
